import { ProductTile } from '../../components/AutoGenerate/types/ProductTile'
import { BFFPageData } from '../../services/serviceClients/BffClient'
import { ReviewsResponse } from '../../types/Contentful/ContentfulTypes'
import { ProductGridItemType, ShortProductTileV2 } from '../../types/TemplateConfiguration'
import PageDataUtil from '../pageDataUtil/pageDataUtil'
import { PageAvailabilityHandler } from '../productTileCollection/PageAvailabilityHandler'
import { ProductTileV2 } from '../productTileCollection/productTileCollection'
import { ProductTileV2DataExtractor } from '../productTileCollection/ProductTileV2DataExtractor'
import { MpvTileBuilder } from './MpvTileBuilder'

/**
 * Builds product tiles for lane/carousel layout sections
 */
export class LaneTileBuilder {
  constructor(
    private readonly pageDataFromBFF: BFFPageData,
    private readonly reviewsData: ReviewsResponse | undefined
  ) {}

  /**
   * Builds a complete lane tile from product item
   */
  buildTile(
    item: ProductGridItemType,
    enableCampaignCallouts: boolean | undefined
  ): ProductTile | undefined {
    const tileData = (item.product as ShortProductTileV2)?.template
    if (!tileData) return undefined

    const mpvId = tileData.productsList?.selectedProduct?.mpvId
    const commonFields = ProductTileV2DataExtractor.extractCommonFields(
      tileData,
      item.product?.contentful_id,
      enableCampaignCallouts,
      this.reviewsData,
      mpvId
    )

    if (!mpvId) {
      return {
        ...commonFields,
        associatedPageAvailable: true
      } as ProductTile
    }

    return this.buildMpvLaneTile(commonFields, mpvId, tileData)
  }

  private buildMpvLaneTile(
    commonFields: Partial<ProductTile>,
    mpvId: string,
    tileData: ProductTileV2
  ): ProductTile | undefined {
    const serverSideMpvData = PageDataUtil.getMpv(mpvId, this.pageDataFromBFF)

    if (!serverSideMpvData) {
      return undefined
    }

    const mpvTile = MpvTileBuilder.buildFromMpv(mpvId, serverSideMpvData)
    const associatedPageAvailable = PageAvailabilityHandler.isAvailable(
      mpvId,
      this.pageDataFromBFF.pageAvailabilities,
      ProductTileV2DataExtractor.hasExplicitLink(tileData)
    )

    return {
      ...commonFields,
      associatedPageAvailable,
      ...mpvTile
    } as ProductTile
  }
}
